/**
 * Blog nav: sticky stuck class + All-page scroll spy highlight.
 * Click still goes to tagged pages; highlight is visual only.
 */
(function () {
  const CURRENT_DESKTOP = 'dl-blog-navigation__tag-link--current';
  const CURRENT_MOBILE = 'dl-blog-navigation__panel-link--current';

  function initSticky(navRoot) {
    if (!('IntersectionObserver' in window)) return;
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:relative;top:0;height:1px;width:100%;pointer-events:none;margin:0;padding:0;';
    navRoot.parentNode.insertBefore(sentinel, navRoot);

    const observer = new IntersectionObserver(
      ([entry]) => {
        document.body.classList.toggle('dl-blog-nav-stuck', !entry.isIntersecting);
      },
      { threshold: [1] }
    );
    observer.observe(sentinel);
  }

  function initScrollSpy(navRoot) {
    const sections = Array.from(document.querySelectorAll('.blog-by-tag-block[data-blog-tag]'));
    if (!sections.length) return;

    const desktopLinks = Array.from(navRoot.querySelectorAll('.dl-blog-navigation__tag-link[data-blog-tag]'));
    const mobileLinks = Array.from(navRoot.querySelectorAll('.dl-blog-navigation__panel-link[data-blog-tag]'));
    const mobileCurrent = navRoot.querySelector('.dl-blog-navigation__current');
    const labelMap = {};

    desktopLinks.forEach((link) => {
      const key = link.getAttribute('data-blog-tag');
      if (key) labelMap[key] = link.textContent.trim();
    });

    let activeTag = '';

    function setActive(tag) {
      if (tag === activeTag) return;
      activeTag = tag;

      desktopLinks.forEach((link) => {
        link.classList.toggle(CURRENT_DESKTOP, link.getAttribute('data-blog-tag') === tag);
      });
      mobileLinks.forEach((link) => {
        link.classList.toggle(CURRENT_MOBILE, link.getAttribute('data-blog-tag') === tag);
      });
      if (mobileCurrent && labelMap[tag]) {
        mobileCurrent.textContent = labelMap[tag];
      }
    }

    function update() {
      const navBottom = navRoot.getBoundingClientRect().bottom;
      let next = 'all';

      for (let i = 0; i < sections.length; i += 1) {
        const section = sections[i];
        const top = section.getBoundingClientRect().top;
        if (top <= navBottom + 12) {
          next = section.getAttribute('data-blog-tag') || 'all';
        } else {
          break;
        }
      }

      setActive(next);
    }

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    const navRoot = document.querySelector('.dl-blog-navigation-root');
    if (!navRoot) return;
    initSticky(navRoot);
    if (navRoot.hasAttribute('data-blog-nav-spy')) {
      initScrollSpy(navRoot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
